import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
interface CancellationSuccessToastProps {
  detail: string;
  onDismiss: () => void;
}

/** Confirmation shown on Home once a subscription has been cancelled. */
export function CancellationSuccessToast({
  detail,
  onDismiss
}: CancellationSuccessToastProps) {
  const {
    isLight
  } = useTheme();
  useEffect(() => {
    const t = window.setTimeout(onDismiss, 5000);
    return () => window.clearTimeout(t);
  }, [onDismiss]);
  return <motion.div role="status" aria-live="polite" initial={{
    opacity: 0,
    y: -12,
    scale: 0.98
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} exit={{
    opacity: 0,
    y: -12,
    scale: 0.98
  }} transition={{
    duration: 0.24,
    ease: [0.23, 1, 0.32, 1]
  }} className={`absolute inset-x-4 top-12 z-[70] flex items-start gap-3 rounded-2xl border p-3.5 shadow-[0_12px_32px_-12px_rgba(15,23,42,0.35)] ${isLight ? 'border-slate-200 bg-white' : 'border-white/10 bg-[#1c1c1e]'}`} data-id="element-337" data-mp="1wlih65w6qep2">
      <span className={`grid h-9 w-9 flex-shrink-0 place-items-center rounded-full ${isLight ? 'bg-vexu/10 text-vexu-700' : 'bg-vexu/15 text-vexu'}`} aria-hidden data-id="element-338" data-mp="2wjbqmt9xknmw">
        <CheckCircle2 className="h-5 w-5" data-id="element-339" data-mp="2nj5dx9m23ros" />
      </span>
      <div className="min-w-0 flex-1 pt-0.5" data-id="element-340" data-mp="2nilwrv48d7bt">
        <p className={`text-sm font-bold ${isLight ? 'text-slate-900' : 'text-white'}`} data-id="element-341" data-mp="2ijsk24wrpkcp">Subscription cancelled</p>
        <p className={`mt-0.5 text-xs leading-relaxed ${isLight ? 'text-slate-500' : 'text-zinc-400'}`} data-id="element-342" data-mp="2dsu3r5bs4m9g">{detail}</p>
      </div>
      <button type="button" onClick={onDismiss} aria-label="Dismiss" className={`-mr-1 -mt-1 rounded-full p-1.5 transition-colors ${isLight ? 'text-slate-400 hover:bg-slate-100' : 'text-zinc-500 hover:bg-white/10'}`} data-id="element-343" data-mp="28v0wsa2njo84">
        <X className="h-4 w-4" data-id="element-344" data-mp="1uuq554tiq5lw" />
      </button>
    </motion.div>;
}